import { jsx as _jsx } from "react/jsx-runtime";
import { useId } from 'react';
export function useAccesebilityPanel(title) {
    const headingId = useId();
    return {
        panelAttributes: {
            role: 'region',
            'aria-labelledby': headingId
        },
        panelHeader: (_jsx("h2", { id: headingId, style: {
                position: 'absolute',
                width: '1px',
                height: '1px',
                padding: 0,
                margin: '-1px',
                overflow: 'hidden',
                clip: 'rect(0, 0, 0, 0)',
                whiteSpace: 'nowrap',
                border: 0
            }, children: title }))
    };
}
export function setFocusVisible(element) {
    if (isNullOrUndefined(element) || element instanceof HTMLElement === false) {
        return;
    }
    element.focus({ focusVisible: true }); //NOSONAR S4325: focusVisible is not provided in typescript, but it is supported all browsers (https://github.com/microsoft/TypeScript/issues/61458)
}
